import { render, staticRenderFns } from "./RegisterAccountPlans.vue?vue&type=template&id=0501c702&"
import script from "./RegisterAccountPlans.vue?vue&type=script&lang=js&"
export * from "./RegisterAccountPlans.vue?vue&type=script&lang=js&"
import style0 from "./RegisterAccountPlans.vue?vue&type=style&index=0&id=0501c702&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports